import { createAsyncAction } from "../utils/actionCreators";

export const types = {
  RESUMO: "@@clientes/RESUMO",
  LISTAR: "@@clientes/LISTAR",
  OBTER: "@@clientes/OBTER",
  OBTER_PARCEIROS: "@@clientes/OBTER_PARCEIROS",
  OBTER_PRODUTOS: "@@clientes/OBTER_PRODUTOS",
  OBTER_INSTITUICOES_FINANCEIRAS: "@@clientes/OBTER_INSTITUICOES_FINANCEIRAS",
  DOWNLOAD_DOCUMENTO: "@@clientes/DOWNLOAD_DOCUMENTO",
  OBTER_DOMINIOS: "@@cliente/OBTER_DOMINIOS",
  OBTER_PREENCHIMENTO: "@@cliente/OBTER_PREENCHIMENTO",
  GRAVAR_PREENCHIMENTO: "@@cliente/GRAVAR_PREENCHIMENTO",
  ENVIAR_PREENCHIMENTO: "@@cliente/ENVIAR_PREENCHIMENTO",
  REFRESH_PREENCHIMENTO: "@@cliente/REFRESH_PREENCHIMENTO",
};

export const actions = {
  listarClientes: createAsyncAction(types.LISTAR),
  carregarResumo: createAsyncAction(types.RESUMO),
  obterCliente: createAsyncAction(types.OBTER),
  obterParceiros: createAsyncAction(types.OBTER_PARCEIROS),
  obterProdutos: createAsyncAction(types.OBTER_PRODUTOS),
  obterInstituicoesFinanceiras: createAsyncAction(
    types.OBTER_INSTITUICOES_FINANCEIRAS
  ),
  downloadDocumento: createAsyncAction(types.DOWNLOAD_DOCUMENTO),
  obterDominios: createAsyncAction(types.OBTER_DOMINIOS),
  obterPreenchimento: createAsyncAction(types.OBTER_PREENCHIMENTO),
  gravarPreenchimento: createAsyncAction(types.GRAVAR_PREENCHIMENTO),
  enviarPreenchimento: createAsyncAction(types.ENVIAR_PREENCHIMENTO),
  refreshPreenchimento: createAsyncAction(types.REFRESH_PREENCHIMENTO),
};
